<script setup lang="ts">
import AppButton from '@/shared/ui/AppButton/index';
import { ROOT_JOURNAL_URL } from '@/shared/constants/urlConstants';
import { modifyDate } from '@/shared/utils/modifyTime';
import type { IJournalArticle } from '@/entities/journal/model/types';

const props = defineProps<{ article: IJournalArticle }>();

const isMobile: boolean = useIsMobile();

const articleLink: ComputedRef<string> = computed(
  () => `${ROOT_JOURNAL_URL}${props.article.topic?.slug ?? ''}/${props.article.slug}/`,
);

const publishedAt: ComputedRef<string> = computed(() =>
  modifyDate(props.article.created_at),
);

const title: ComputedRef<string> = computed(() => props.article.content?.title ?? '');
</script>

<template>
  <article
    :class="['lawyer-article-card', { _mobile: isMobile }]"
    data-testid="lawyer-article-card"
  >
    <NuxtImg
      class="lawyer-article-card__image"
      :src="article.content?.preview"
      :alt="title || 'превью статьи'"
      sizes="xs:100vw sm:140px"
      width="140"
      height="105"
      loading="lazy"
    />
    <div class="lawyer-article-card__content">
      <div class="lawyer-article-card__date">Опубликовано: {{ publishedAt }}</div>
      <div class="lawyer-article-card__text">{{ title }}</div>
      <AppButton
        class="lawyer-article-card__button"
        button-text="Подробнее"
        is-small
        is-white
        is-bordered
        :to="articleLink"
      />
    </div>
  </article>
</template>

<style lang="less">
.lawyer-article-card {
  display: flex;
  align-items: center;
  gap: @size-x5;
  padding: @size-x5;
  border: 1px solid @color-gallery;
  border-radius: @size-x2;

  &__image {
    display: block;
    object-fit: cover;
    max-width: 140px;
    min-width: 140px;
    height: 105px;
    border-radius: @size-x2;
  }

  &__content {
    .flex-column(@size-x3);

    width: 100%;
  }

  &__date {
    font-size: @size-x3;
    line-height: @size-x4;
    font-weight: 500;
    color: @color-manatee;
  }

  &__text {
    .overflow-ellipsis-lines();

    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
  }

  & &__button._small {
    width: 140px;
    min-height: @size-x8;
    padding: @main-size @size-x4;
  }

  &._mobile {
    flex-wrap: wrap;
  }

  &._mobile &__image {
    width: 100%;
    max-width: 100%;
    height: 145px;
  }
}
</style>
